export default __webpack_public_path__ + "static/media/cert-ngo-cpttm.58b9ea14.jpg";